import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { AddFundDividendForm } from './AddFundDividendForm'

export const AddFundDividendCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, isinKey } = useHook('routing.general.useFundPricesParams')()
  const actions = useHook('mutators.unitlink.useAddFundDividendActions')({
    tenantId,
    isinKey,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="unitLink.AddFundDividendCommandData"
      title={translate('fund.actions.addDividend')}
      commandDataForm={AddFundDividendForm}
      submit={submit}
      {...props}
    />
  )
}
